import { useState, useEffect } from 'react'
import useStore from '../../../../../store/useStore'
import { Regimen } from '../../../../../types/Regimen'

/**
 * Hook to fetch dental procedures for the current user
 * @returns Object containing dental procedures and loading state
 */
const useDentalProcedures = () => {
  const user = useStore((state) => state.user)
  const [dentalProcedures, setDentalProcedures] = useState<Regimen[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDentalProcedures = async () => {
      if (!user) {
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        // Get regimens from store if available
        const regimens = useStore.getState().regimens
        const procedures = regimens
          .filter((regimen) => regimen.list === 'dental')
          .sort((a: Regimen, b: Regimen) => {
            const aDate = a.usages?.[a.usages.length - 1]?.startDate
            const bDate = b.usages?.[b.usages.length - 1]?.startDate

            if (!aDate) return 1
            if (!bDate) return -1

            return new Date(bDate).getTime() - new Date(aDate).getTime()
          })

        setDentalProcedures(procedures)
      } catch (error) {
        console.error('Error fetching dental procedures:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDentalProcedures()
  }, [user])

  return { dentalProcedures, loading }
}

export default useDentalProcedures
